import { getLoginToken } from './axios.js';
import {
  assertLoginEnvironment,
  expireAuthSession,
  isUnauthorizedResponse
} from './auth.js';

// 创建统一的请求函数
const request = async (url, method = 'GET', data = null) => {
  // 从 localStorage 获取 manager_url
  const baseManagerUrl = localStorage.getItem('selectedEnvManagerUrl');
  
  // 如果没有 manager_url，直接抛出错误
  if (!baseManagerUrl || baseManagerUrl === 'null') {
    const error = new Error('请先选择环境，manager_url 不能为空');
    console.error('API 请求错误:', error.message);
    throw error;
  }
  
  const fullUrl = `${baseManagerUrl}${url}`;
  
  // 操作记录的查询和写入接口均走 oauth2，只能使用当前登录令牌。
  const token = getLoginToken();

  if (!token) {
    expireAuthSession();
    throw new Error('登录状态已失效，请重新登录');
  }

  // 登录令牌仅允许访问登录时选择的环境，避免跨环境 401 被误判为 token 过期。
  assertLoginEnvironment(baseManagerUrl);
  
  // 构建请求头
  const headers = {
    'Content-Type': 'application/json'
  };
  
  headers.Authorization = token;

  try {
    const response = await fetch(fullUrl, {
      method,
      headers,
      ...(data && { body: JSON.stringify(data) })
    });

    const result = await response.json().catch(() => null);
    if (isUnauthorizedResponse(response.status, result)) {
      expireAuthSession();
      throw new Error('登录状态已失效，请重新登录');
    }
    if (!response.ok || result?.code !== 0) {
      throw new Error(result?.msg || `请求失败 (${response.status})`);
    }
    return result;
  } catch (error) {
    console.error('API 请求错误:', error);
    throw error;
  }
};

// 封装操作记录相关 API
const operationRecordAPI = {
  getPage: (params) => request('/xiaozhi/robot/operation/page', 'POST', params),
  getTenants: () => request('/xiaozhi/tenant/page?page=1&limit=1000&status=1'),
  getDetail: (id) => request(`/xiaozhi/robot/operation/detail?id=${id}`),
  toggleFavorite: (id, isFavorited) => request('/xiaozhi/robot/operation/favorite', 'POST', {
    id,
    isFavorited: !isFavorited ? 1:0
  }),
  delete: (id) => request(`/xiaozhi/robot/operation/delete?id=${id}`, 'POST'),
  // 保存/新增操作记录（用于导入）
  save: (record) => request('/xiaozhi/robot/operation/save', 'POST', record),
  // 获取全部记录（用于全量导出），通过分页接口一次性拉取
  getAll: (params = {}) => request('/xiaozhi/robot/operation/page', 'POST', {
    page: 1,
    limit: 100000,
    ...params
  })
};

export default operationRecordAPI;
